// import styles and images
import './App.css';

// import dependencies
import * as React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// import dependencies
import Navigation from './components/Navigation.jsx';
import SiteDate from './components/date.js';
import Header from "./components/Header.jsx";
import { Message } from "./components/Message";
import DisclaimerPage from "./pages/DisclaimerPage";
import Footer from "./components/Footer.jsx";
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.jsx';


// import pages
import HomePage from './pages/HomePage.jsx';
import WcaPage from './pages/WcaPage.jsx';
import CompassPage from './pages/CompassPage.jsx';
import WtBalPage from "./pages/WtBalPage.jsx";
import CrosswindPage from "./pages/CrosswindPage.jsx";
import DensityAltPage from "./pages/DensityAltPage.jsx";
import WebLinksPage from "./pages/WebLinksPage.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import PartsPage from "./pages/PartsPage.jsx";

function AppContent() {
  const location = useLocation();

  const titles = {
  "/": "Preflight Tools",
  "/winds": "Winds Aloft & WCA Calculator",
  "/compass": "Compass Turns",
  "/cw": "Crosswind Calculator",
  "/density-altitude": "Density Altitude Calculator",
    };

  const headerTitle = titles[location.pathname] || "Preflight Tools";
        
  return (
    <>
      <Header title={headerTitle} />

      <Navigation />
  

      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/density-altitude" element={<DensityAltPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/cw" element={<CrosswindPage />} />
          <Route path="/winds" element={<WcaPage />} />
          <Route path="/compass" element={<CompassPage />} />
          <Route path="/wtbals" element={<WtBalPage />} />  
          <Route path="/web-links" element={<WebLinksPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/parts" element={<PartsPage />} />

        </Routes>
      </main>

      <footer>
        
        <div style={{marginTop: "10px", fontSize: "14px", color: "#666"}}>
           &copy;2026. FlyAviCalc.com. All rights reserved.
        </div>
        
        <div 
          style={{marginTop: "20px",
        }}>

          <div >
            <Footer />
            
          </div>
        </div>
      </footer>
    </>
  );
}
    

function App() {
  return (
    <div className="App_router">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}
export default App;
